import { __awaiter, __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import { CountryId, ErrorMessage, HTTPStatusCode } from '@as-react/common-types';
import { yupResolver } from '@hookform/resolvers/yup';
import { MagnifyingGlassIcon } from '@yonderland/andes-icons';
import { IconButton, SearchFieldAlpha, Stack } from '@yonderland/andes-react';
import { useForm, FormProvider } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as Yup from 'yup';
import { I18N_NAMESPACES } from '../../../../constants/i18nConstants';
import { useDeliveryState, usePickupPointSearchContext } from '../../../../context/CheckoutDeliveryContext';
import { isValidPostCode } from '../../../form/address-fields/addressFields.utils';
import { FormField } from '../../../form/FormField';
const getErrorMessageKey = (countryId) => {
    switch (countryId) {
        case CountryId.BE:
            return ErrorMessage.INVALID_POSTAL_CODE_BE;
        case CountryId.NL:
            return ErrorMessage.INVALID_POSTAL_CODE_NL;
        case CountryId.FR:
        case CountryId.DE:
            return ErrorMessage.INVALID_POSTAL_CODE_DE_FR;
        case CountryId.GB:
        case CountryId.GG:
        case CountryId.JE:
            return ErrorMessage.INVALID_POSTAL_CODE_UK;
        default:
            return ErrorMessage.API_ERROR;
    }
};
export const PickupPointSearchForm = () => {
    const { t } = useTranslation(I18N_NAMESPACES.checkout);
    const [{ info: { idCountry }, },] = useDeliveryState();
    const { locationSearch, setLocationSearch, getPickupPointsQuery } = usePickupPointSearchContext();
    const { isLoading, error: getPickupPointsError, data: getPickupPointsResponse } = getPickupPointsQuery;
    const validationSchema = Yup.object({
        location: Yup.string()
            .required(t(ErrorMessage.REQUIRED))
            .test('checkPostcode', t(getErrorMessageKey(idCountry)), value => isValidPostCode(value, idCountry)),
    });
    const formProps = useForm({
        defaultValues: { location: locationSearch },
        mode: 'onTouched',
        resolver: yupResolver(validationSchema),
    });
    const handleSubmit = (_a) => __awaiter(void 0, [_a], void 0, function* ({ location }) {
        setLocationSearch(location.trim());
    });
    const showError = (getPickupPointsError && !isLoading) ||
        (getPickupPointsResponse && getPickupPointsResponse.status === HTTPStatusCode.NoContent);
    return (_jsx(FormProvider, Object.assign({}, formProps, { children: _jsx("form", { onSubmit: formProps.handleSubmit(handleSubmit), noValidate: true, name: "pickup-point-search-form", children: _jsx(Stack, { direction: "col", gap: "6", children: _jsx(FormField, { name: "location", children: (_a) => {
                        var _b = _a.fieldProps, { ref } = _b, options = __rest(_b, ["ref"]), { error } = _a;
                        return (_jsx(SearchFieldAlpha, Object.assign({}, options, { autoSearch: true, input: {
                                testId: 'pickuppoint_finder_input',
                                id: 'pickuppoint-location',
                                autoComplete: 'location',
                                placeholder: t('checkout.delivery.pickuppoint.search.postcode'),
                                error: showError ? t('checkout.delivery.pickuppoint.no.results') : error,
                                adornmentStart: (_jsx(IconButton, { testId: "pickuppoint_finder_input_search", variant: "plain", size: "sm", icon: { source: MagnifyingGlassIcon }, type: "submit" })),
                                disabled: isLoading,
                            } })));
                    } }) }) }) })));
};
